var api = require("!../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../css-loader/dist/cjs.js!../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?{\"source\":\"LnpveXVtbjAgewogIGRpc3BsYXk6IGZsZXg7CiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjsKICBhbGlnbi1pdGVtczogY2VudGVyOwogIGp1c3RpZnktY29udGVudDogY2VudGVyOwogIGdhcDogMTVweDsKfQouem95dW1uMSB7CiAgbWFyZ2luOiAycHggMCAwIDA7CiAgd2lkdGg6IDEwMCU7CiAgbWF4LXdpZHRoOiA4NDZweDsKICBmb250LXNpemU6IDE0cHg7CiAgdGV4dC1hbGlnbjogbGVmdDsKICBjdXJzb3I6IHBvaW50ZXI7Cn0=\"}!./vanilla-extract-webpack-plugin-extracted.cjs.js");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};